
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 11a1 1 0 11-2 0 1 1 0 012 0z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5 3a3 3 0 00-3 3v10c0 1.306.835 2.418 2 2.83V19a2 2 0 104 0h8a2 2 0 104 0v-.17A3.001 3.001 0 0022 16V6a3 3 0 00-3-3H5zm2 6a1 1 0 10-2 0v4a1 1 0 102 0V9zm4.293 5.707a1 1 0 010-1.414l1-1A2.988 2.988 0 0112 11c0-.463.105-.902.292-1.293l-1-1a1 1 0 011.415-1.414l1 1C14.098 8.104 14.537 8 15 8c.463 0 .902.105 1.293.292l1-1a1 1 0 111.414 1.415l-1 1c.188.391.293.83.293 1.293 0 .463-.105.902-.292 1.294l.999.999a1 1 0 01-1.414 1.414l-1-1c-.391.188-.83.293-1.293.293-.463 0-.902-.105-1.293-.292l-1 .999a1 1 0 01-1.414 0z"}})])
          )
        }
      }
    